import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the <strong>report dropdown</strong> to choose from the available report types. Each report provides different analytics and metrics." id="use_the_report_dropdown_to_choose_from_t.c7f4415d" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Selecting a Report" id="selecting_a_report.37056b07" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Narrow your report data by applying filters such as <strong>student</strong>, <strong>group</strong>, <strong>partner</strong>, or <strong>date range</strong>. Filters update the report results in real time." id="narrow_your_report_data_by_applying_filt.eefaf68b" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Applying Filters" id="applying_filters.4f3a0dbb" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Many reports include interactive <strong>charts</strong>, <strong>progress bars</strong>, and <strong>skill trees</strong>. Hover over chart elements for detailed breakdowns." id="many_reports_include_interactive_charts.0e0c5706" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Charts & Visualizations" id="charts_and_visualizations.865752f5" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="<strong>Export</strong> report data for offline analysis or sharing with stakeholders." id="export_report_data_for_offline_analysis.b2a88c64" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Exporting Data" id="exporting_data.ec77bfb8" />
        }
    ],
    title: <FormattedMessage defaultMessage="Reports" id="reports.c01b78b6" />
};
